import { Component } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { HttpAgentAdminService } from '../../../../service/http-agent.service';

@Component({
  selector: 'app-agent-admin-list',
  standalone: false,
  templateUrl: './agent-admin-list.component.html',
  styleUrl: './agent-admin-list.component.scss'
})
export class AgentAdminListComponent {
	data: AgentDto[] = [];
	constructor(private httpService: HttpAgentAdminService){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

}
